/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { DynamicFormService } from '@ntap/common';
import { Component, Optional } from '@angular/core';
import {
  DataSource,
  Item,
  ItemActionResult,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction,
  ViewWindow
} from '@ntap/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-confirm-vrsta-zahtjeva-action',
  templateUrl: '../../shared/components/actions/common-action-template.html'
})
export class PotvrdiVrstaZahtjevaActionComponent extends ServerItemAction {
  itemViewProvider: ItemViewProviderDirective<ItemView>;
  dynamicFormService: DynamicFormService;
  vrstaZahtjevaAttribute = 'en~zahtjev~vrsta_zahtjeva_id';
  static CONCRETE_ZAHTJEV_ITEMVIEW_NAME = 'concrete_zahtjev_item';
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override window: ViewWindow,
    itemViewProvider: ItemViewProviderDirective<ItemView>,
    dynamicFormService: DynamicFormService
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.itemViewProvider = itemViewProvider;
    this.dynamicFormService = dynamicFormService;
    this.setShowMessages(false);
  }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    this.dynamicFormService.formGroup.updateValueAndValidity({
      emitEvent: false
    });
    this.dynamicFormService.formSubmitted.emit(true);
    this.checkFormInvalid();
    const originalFormValues = this.getFormParams();
    (item as any)[this.vrstaZahtjevaAttribute] =
      originalFormValues[this.vrstaZahtjevaAttribute];
    return super.doExecuteWithItem(item);
  }

  protected override updateItem(itemActionResult: ItemActionResult): void {
    const vrstaZahtjevaId = (itemActionResult.item as any)[
      this.vrstaZahtjevaAttribute
    ];
    (this.itemViewProvider.viewState as any)[this.vrstaZahtjevaAttribute] =
      vrstaZahtjevaId;
    const viewStateCopy = Object.assign({}, this.itemViewProvider.viewState);
    this.itemViewProvider.viewName =
      PotvrdiVrstaZahtjevaActionComponent.CONCRETE_ZAHTJEV_ITEMVIEW_NAME;
    this.itemViewProvider.viewState = viewStateCopy;
  }

  private checkFormInvalid() {
    if (this.dynamicFormService.formGroup.invalid) {
      const message = 'Forma nije dobro popunjena!';
      this.notificationService.error(message);
      throw new Error(message);
    }
  }

  getFormParams(): any {
    return this.dynamicFormService.getFormValues();
  }
}
